import translations from './translations/translations.reducer'
import customerOrders from './orders/orders.reducer'

export default {
  translations,
  customerOrders
}
